module.exports = __webpack_public_path__ + "img/home_pic_3.0_4.885b6cd6.webp";